export function getFirstUpper(name: string) {
	if (!name) {
		return '';
	}

	const upperName = name?.[0]?.toUpperCase() + name.slice(1);
	return upperName;
}
